import type { Currency, DocumentType, ExpenseKind } from '@kmdx/contracts';

/** Всичко, което шофьорът чете. Без съкращения, без чуждици, без жаргон. */

export const DOCUMENT_LABELS: Record<DocumentType, string> = {
  cmr: 'ЧМР товарителница',
  pod: 'Разписка за доставка',
  delivery_note: 'Стокова разписка',
  packing_list: 'Опаковъчен лист',
  invoice: 'Фактура',
  purchase_invoice: 'Фактура за покупка',
  fuel_receipt: 'Бележка за гориво',
  toll_receipt: 'Бележка за такса път',
  ferry_ticket: 'Билет за ферибот',
  weighbridge: 'Кантарна бележка',
  photo_loading: 'Снимка на товара',
  photo_damage: 'Снимка на повреда',
  photo_seal: 'Снимка на пломбата',
  customs: 'Митнически документ',
  insurance: 'Застраховка',
  vehicle_document: 'Документ на буса',
  driver_document: 'Документ на шофьора',
  transport_order: 'Заявка от клиента',
  odometer: 'Километраж',
  vehicle_registration: 'Талон',
  id_card: 'Лична карта',
  driving_licence: 'Шофьорска книжка',
  medical_certificate: 'Медицинско',
  criminal_record: 'Свидетелство за съдимост',
  bank_details: 'Банкова сметка',
  certificate: 'Сертификат',
  posting_certificate: 'Удостоверение Macron',
  vignette: 'Винетка',
  other: 'Друг документ',
};

/** Какво реално се снима на рампата — останалото не се показва на телефона. */
export const CAPTURABLE_DOCUMENTS: DocumentType[] = [
  'cmr',
  'pod',
  'delivery_note',
  'packing_list',
  'photo_loading',
  'photo_damage',
  'photo_seal',
  'weighbridge',
  'other',
];

export const EXPENSE_LABELS: Record<ExpenseKind, string> = {
  fuel: 'Гориво',
  adblue: 'AdBlue',
  toll: 'Такса път',
  vignette: 'Винетка',
  ferry: 'Ферибот',
  parking: 'Паркинг',
  accommodation: 'Нощувка',
  per_diem: 'Командировъчни',
  repair: 'Ремонт на пътя',
  tyres: 'Гуми',
  wash: 'Мивка',
  fine: 'Глоба',
  customs_fee: 'Митническа такса',
  subcontractor: 'Подизпълнител',
  other: 'Друго',
};

/**
 * Само непредвидените разходи. Горивото, AdBlue, пътните такси, винетките и
 * фериботите се плащат със служебната карта, която стои във всеки бус, и идват
 * в офиса с извлечението на картата — шофьорът не ги въвежда.
 */
export const DRIVER_EXPENSE_KINDS: ExpenseKind[] = [
  'repair',
  'tyres',
  'parking',
  'wash',
  'accommodation',
  'fine',
  'other',
];

/** Валутите, които реално се плащат в брой по маршрутите на фирмата. */
export const DRIVER_CURRENCIES: Currency[] = ['EUR', 'CHF', 'HUF', 'RON', 'PLN', 'CZK'];

export const COUNTRY_NAMES: Record<string, string> = {
  AT: 'Австрия',
  BE: 'Белгия',
  BG: 'България',
  CH: 'Швейцария',
  CZ: 'Чехия',
  DE: 'Германия',
  DK: 'Дания',
  ES: 'Испания',
  FR: 'Франция',
  GR: 'Гърция',
  HR: 'Хърватия',
  HU: 'Унгария',
  IT: 'Италия',
  LU: 'Люксембург',
  NL: 'Нидерландия',
  PL: 'Полша',
  PT: 'Португалия',
  RO: 'Румъния',
  RS: 'Сърбия',
  SE: 'Швеция',
  SI: 'Словения',
  SK: 'Словакия',
};

/** Държавите по обичайните маршрути Пловдив → Германия/Италия/Австрия. */
export const COMMON_COUNTRIES = ['BG', 'RO', 'HU', 'AT', 'DE', 'IT', 'SI', 'SK', 'CZ', 'HR', 'PL'];

export function countryName(code: string | null | undefined): string {
  if (!code) return '—';
  return COUNTRY_NAMES[code.toUpperCase()] ?? code.toUpperCase();
}

export const VEHICLE_CHECK_ITEMS: { key: string; label: string }[] = [
  { key: 'tyres', label: 'Гуми и налягане' },
  { key: 'lights', label: 'Светлини и мигачи' },
  { key: 'brakes', label: 'Спирачки' },
  { key: 'fluids', label: 'Масло, вода, AdBlue' },
  { key: 'body', label: 'Каросерия и врати' },
  { key: 'straps', label: 'Колани и ремъци за укрепване' },
  { key: 'documents', label: 'Документи на буса в кабината' },
  { key: 'extinguisher', label: 'Пожарогасител и аптечка' },
  { key: 'cleanliness', label: 'Чист товарен отсек' },
];
